const texts = {
  edit: "수정하기",
  goBack: "뒤로가기",
  delete: "삭제하기",
  color: "#ab57ff",
};

export default texts;
